/**
 * @constant {{
 * CAMPAIGNS: String,
 * CONNECTOR: String,
 * WEB_TRACKING: String,
 * LEAD_SCORING: String
 * }}
 */
const Features = Object.freeze({
	CAMPAIGNS: 'campaigns',
	CONNECTOR: 'connector',
	WEB_TRACKING: 'webTracking',
	LEAD_SCORING: 'leadScoring',
	LEAD_SCORING_CRM_ACTIVITIES: 'leadScoringCrmActivities'
});

export {
	Features
};
